import * as React from 'react'
import { ReactElement } from 'react'
import LegacyBaseDialog from './LegacyBaseDialog'
import { ActionButton, DialogFooter, IDialogProps, PrimaryButton } from '@fluentui/react'
import { useTranslation } from 'react-i18next'

export type DeleteDialogProps = IDialogProps & {
    onDelete: React.MouseEventHandler<any>
}

// noinspection JSUnusedGlobalSymbols
export default function LegacyDeleteDialog(props: DeleteDialogProps): ReactElement {
    const { t: translate } = useTranslation()

    return (
        <LegacyBaseDialog
            dialogContentProps={{
                title: translate('base.delete.title'),
                subText: translate('base.delete.subtitle'),
            }}
            {...props}
        >
            <DialogFooter>
                <PrimaryButton
                    className="ms-bgColor-red ms-bgColor-redDark--hover ms-fontColor-white ms-fontColor-white--hover"
                    text={translate('base.delete.submit')}
                    onClick={event => {
                        props.onDelete(event)
                        props.onDismiss()
                    }}
                />
                <ActionButton text={translate('base.delete.cancel')} onClick={props.onDismiss} autoFocus />
            </DialogFooter>
        </LegacyBaseDialog>
    )
}
